export const twitterIcon = (w = 26, h = 21, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 26 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 2.49454C25.0439 2.9046 24.0034 3.19972 22.9316 3.31466C24.0443 2.65743 24.8776 1.61912 25.2751 0.394539C24.2309 1.01208 23.0871 1.44511 21.8942 1.67442C21.3957 1.14453 20.7927 0.722399 20.1229 0.434326C19.4531 0.146252 18.7308 -0.00158986 18.001 1.28933e-05C15.0482 1.28933e-05 12.6735 2.3796 12.6735 5.29971C12.6735 5.70977 12.7235 6.11983 12.8047 6.51436C8.38337 6.28448 4.44009 4.18448 1.81853 0.969243C1.34086 1.7804 1.09054 2.704 1.09362 3.64394C1.09362 5.483 2.03413 7.10459 3.46833 8.05829C2.62314 8.0252 1.79773 7.79423 1.05925 7.38418V7.44942C1.05925 10.0247 2.89028 12.1589 5.33061 12.6497C4.87241 12.768 4.40106 12.8286 3.92765 12.8299C3.58082 12.8299 3.25273 12.7957 2.92152 12.7491C3.59644 14.8491 5.56183 16.3744 7.90217 16.4241C6.07115 17.85 3.77767 18.6888 1.28735 18.6888C0.840524 18.6888 0.428074 18.6732 0 18.6235C2.36222 20.1302 5.165 21 8.18339 21C17.9822 21 23.3441 12.9293 23.3441 5.92412C23.3441 5.69424 23.3441 5.46436 23.3284 5.23448C24.3658 4.4796 25.2751 3.54454 26 2.49454Z"
      fill={color}
    />
  </svg>
);

export const instagramIcon = (w = 25, h = 26, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 0C15.8962 0 16.32 0.0129999 17.6525 0.0779999C18.9837 0.143 19.89 0.3601 20.6875 0.6825C21.5125 1.0127 22.2075 1.4599 22.9025 2.1814C23.5381 2.83126 24.0299 3.61737 24.3438 4.485C24.6525 5.3131 24.8625 6.2569 24.925 7.6414C24.9838 9.0272 25 9.4679 25 13C25 16.5321 24.9875 16.9728 24.925 18.3586C24.8625 19.7431 24.6525 20.6856 24.3438 21.515C24.0308 22.3831 23.5389 23.1694 22.9025 23.8186C22.2775 24.4794 21.5216 24.9909 20.6875 25.3175C19.8912 25.6386 18.9837 25.857 17.6525 25.922C16.32 25.9831 15.8962 26 12.5 26C9.10375 26 8.68 25.987 7.3475 25.922C6.01625 25.857 5.11 25.6386 4.3125 25.3175C3.47791 24.9918 2.72191 24.4802 2.0975 23.8186C1.46176 23.1688 0.969914 22.3827 0.65625 21.515C0.34625 20.6869 0.1375 19.7431 0.0749999 18.3586C0.0162499 16.9728 0 16.5321 0 13C0 9.4679 0.0124999 9.0272 0.0749999 7.6414C0.1375 6.2556 0.34625 5.3144 0.65625 4.485C0.969045 3.61683 1.461 2.83052 2.0975 2.1814C2.72209 1.52 3.47804 1.00845 4.3125 0.6825C5.11 0.3601 6.015 0.143 7.3475 0.0779999C8.68 0.0168999 9.10375 0 12.5 0ZM12.5 6.5C10.8424 6.5 9.25268 7.18482 8.08058 8.40381C6.90848 9.62279 6.25 11.2761 6.25 13C6.25 14.7239 6.90848 16.3772 8.08058 17.5962C9.25268 18.8152 10.8424 19.5 12.5 19.5C14.1576 19.5 15.7473 18.8152 16.9194 17.5962C18.0915 16.3772 18.75 14.7239 18.75 13C18.75 11.2761 18.0915 9.62279 16.9194 8.40381C15.7473 7.18482 14.1576 6.5 12.5 6.5ZM20.625 6.175C20.625 5.74402 20.4604 5.3307 20.1674 5.02595C19.8743 4.7212 19.4769 4.55 19.0625 4.55C18.6481 4.55 18.2507 4.7212 17.9576 5.02595C17.6646 5.3307 17.5 5.74402 17.5 6.175C17.5 6.60598 17.6646 7.0193 17.9576 7.32405C18.2507 7.62879 18.6481 7.8 19.0625 7.8C19.4769 7.8 19.8743 7.62879 20.1674 7.32405C20.4604 7.0193 20.625 6.60598 20.625 6.175ZM12.5 9.1C13.4946 9.1 14.4484 9.51089 15.1517 10.2423C15.8549 10.9737 16.25 11.9657 16.25 13C16.25 14.0343 15.8549 15.0263 15.1517 15.7577C14.4484 16.4891 13.4946 16.9 12.5 16.9C11.5054 16.9 10.5516 16.4891 9.84835 15.7577C9.14509 15.0263 8.75 14.0343 8.75 13C8.75 11.9657 9.14509 10.9737 9.84835 10.2423C10.5516 9.51089 11.5054 9.1 12.5 9.1Z"
      fill={color}
    />
  </svg>
);

export const linkedinIcon = (w = 26, h = 26, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1111 0C23.8773 0 24.6121 0.304364 25.1539 0.846136C25.6956 1.38791 26 2.12271 26 2.88889V23.1111C26 23.8773 25.6956 24.6121 25.1539 25.1539C24.6121 25.6956 23.8773 26 23.1111 26H2.88889C2.12271 26 1.38791 25.6956 0.846136 25.1539C0.304364 24.6121 0 23.8773 0 23.1111V2.88889C0 2.12271 0.304364 1.38791 0.846136 0.846136C1.38791 0.304364 2.12271 0 2.88889 0H23.1111ZM22.3889 22.3889V14.7333C22.3889 13.4845 21.8928 12.2867 21.0097 11.4036C20.1266 10.5206 18.9289 10.0244 17.68 10.0244C16.4522 10.0244 15.0222 10.7756 14.3289 11.9022V10.2989H10.2989V22.3889H14.3289V15.2678C14.3289 14.1556 15.2244 13.2456 16.3367 13.2456C16.873 13.2456 17.3874 13.4586 17.7666 13.8379C18.1458 14.2171 18.3589 14.7315 18.3589 15.2678V22.3889H22.3889ZM5.60444 8.03111C6.24804 8.03111 6.86527 7.77545 7.32036 7.32036C7.77545 6.86527 8.03111 6.24804 8.03111 5.60444C8.03111 4.26111 6.94778 3.16333 5.60444 3.16333C4.95702 3.16333 4.33612 3.42052 3.87832 3.87832C3.42052 4.33612 3.16333 4.95702 3.16333 5.60444C3.16333 6.94778 4.26111 8.03111 5.60444 8.03111ZM7.61222 22.3889V10.2989H3.61111V22.3889H7.61222Z"
      fill={color}
    />
  </svg>
);

export const facebookIcon = (w = 20, h = 20, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 14.84 3.44 18.87 8 19.8V13H6V10H8V7.5C8 5.57 9.57 4 11.5 4H14V7H12C11.45 7 11 7.45 11 8V10H14V13H11V19.95C16.05 19.45 20 15.19 20 10Z"
      fill={color}
    />
  </svg>
);

export const closeIcon = (w = 16, h = 15, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    fill={color}
    viewBox="0 0 16 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.85844 14.5156C2.21268 15.1615 1.16568 15.1615 0.519917 14.5156C-0.125861 13.8698 -0.125861 12.8228 0.519917 12.1771L12.2125 0.484432C12.8584 -0.161345 13.9053 -0.161345 14.5512 0.484432C15.1969 1.13019 15.1969 2.1772 14.5512 2.82296L2.85844 14.5156Z"
      fill={color}
    />
    <path
      d="M0.519917 2.82285C-0.125861 2.17709 -0.125861 1.13008 0.519917 0.484321C1.16568 -0.16144 2.21268 -0.16144 2.85844 0.484321L14.5512 12.177C15.1969 12.8227 15.1969 13.8698 14.5512 14.5155C13.9053 15.1613 12.8584 15.1613 12.2125 14.5155L0.519917 2.82285Z"
      fill={color}
    />
  </svg>
);

export const githubIcon = (w = 32, h = 32, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 0C14.3332 0 12.1876 0.424127 10.1857 1.24817C8.18385 2.0722 6.3649 3.28001 4.83274 4.80264C1.73839 7.87772 0 12.0484 0 16.3972C0 23.6448 4.7355 29.7938 11.286 31.9746C12.111 32.1058 12.375 31.5975 12.375 31.1547V28.3836C7.8045 29.3674 6.831 26.1864 6.831 26.1864C6.072 24.2843 4.9995 23.776 4.9995 23.776C3.498 22.7594 5.115 22.7922 5.115 22.7922C6.765 22.9069 7.6395 24.4811 7.6395 24.4811C9.075 26.9734 11.5005 26.2356 12.441 25.842C12.5895 24.7762 13.0185 24.0547 13.4805 23.6448C9.8175 23.2349 5.973 21.8247 5.973 15.5774C5.973 13.7573 6.6 12.2979 7.6725 11.1337C7.5075 10.7238 6.93 9.01848 7.8375 6.80485C7.8375 6.80485 9.2235 6.36213 12.375 8.47737C13.6785 8.11663 15.0975 7.93626 16.5 7.93626C17.9025 7.93626 19.3215 8.11663 20.625 8.47737C23.7765 6.36213 25.1625 6.80485 25.1625 6.80485C26.07 9.01848 25.4925 10.7238 25.3275 11.1337C26.4 12.2979 27.027 13.7573 27.027 15.5774C27.027 21.8411 23.166 23.2185 19.4865 23.6284C20.0805 24.1367 20.625 25.137 20.625 26.6619V31.1547C20.625 31.5975 20.889 32.1222 21.7305 31.9746C28.281 29.7774 33 23.6448 33 16.3972C33 14.2439 32.5732 12.1117 31.744 10.1223C30.9148 8.13288 29.6994 6.32526 28.1673 4.80264C26.6351 3.28001 24.8161 2.0722 22.8143 1.24817C20.8124 0.424127 18.6668 0 16.5 0Z"
      fill={color}
    />
  </svg>
);

export const barsIcon = (w = 32, h = 32, color = "currentColor") => (
  <svg
    width={w}
    height={h}
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    viewBox="0 0 1792 1792"
  >
    <path d="M1673.9,1363.2L1673.9,1363.2c0,52.3-42.4,94.3-94.3,94.3H212.7c-52.3,0-94.3-42.4-94.3-94.3l0,0  c0-52.3,42.4-94.3,94.3-94.3h1366.8C1631.5,1268.5,1673.9,1310.9,1673.9,1363.2z"></path>
    <path d="M1673.9,895.6L1673.9,895.6c0,52.3-42.4,94.3-94.3,94.3H213c-52.3,0-94.3-42.4-94.3-94.3l0,0c0-52.3,42.4-94.3,94.3-94.3  h1366.6C1631.5,800.8,1673.9,843.2,1673.9,895.6z"></path>
    <path d="M1673.9,427.9L1673.9,427.9c0,52.3-42.4,94.3-94.3,94.3H212.7c-52.3,0-94.3-42.4-94.3-94.3l0,0c0-52.3,42.4-94.3,94.3-94.3  h1366.8C1631.5,333.2,1673.9,375.6,1673.9,427.9z"></path>
  </svg>
);
